import React from 'react';
import { Clock, User, Edit, Trash2 } from 'lucide-react';

const AssiduiteTable = ({ 
  activeTab, 
  retardsEtudiants, 
  retardsEnseignants, 
  handleEdit, 
  handleDelete, 
  formatDate 
}) => {
  const retards = activeTab === 'etudiants' ? retardsEtudiants : retardsEnseignants;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              {activeTab === 'etudiants' ? 'Étudiant' : 'Enseignant'}
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Classe
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Niveau
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Filière
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Module
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Temps
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Motif
            </th>
            <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {retards.length > 0 ? (
            retards.map((retard) => (
              <tr key={retard.id} className="hover:bg-gray-50 transition-colors duration-150">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700">
                  {formatDate(retard.date_retard)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10 bg-[#202654]/10 rounded-full flex items-center justify-center">
                      <User className="h-5 w-5 text-[#202654]" />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">
                        {activeTab === 'etudiants'
                          ? `${retard.etudiant.nom} ${retard.etudiant.prenom}`
                          : `${retard.enseignant.nom} ${retard.enseignant.prenom}`}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {activeTab === 'etudiants' && (
                    <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                      {retard.classe_nom || 'N/A'}
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {activeTab === 'etudiants' ? retard.niveau_nom : 'N/A'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {activeTab === 'etudiants' ? retard.filiere_nom : 'N/A'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-purple-100 text-purple-800">
                    {retard.module_nom || retard.matiere?.libelle || 'N/A'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                    {retard.temps} min
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 max-w-xs truncate">
                  {retard.motif || 'Non spécifié'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex space-x-3">
                    <button
                      onClick={() => handleEdit(retard)}
                      className="text-[#202654] hover:text-[#202654]/80 p-1 rounded-full hover:bg-[#202654]/10 transition-colors"
                      title="Modifier"
                    >
                      <Edit className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => handleDelete(retard.id)}
                      className="text-red-600 hover:text-red-800 p-1 rounded-full hover:bg-red-50 transition-colors"
                      title="Supprimer"
                    >
                      <Trash2 className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="px-6 py-10 text-center text-gray-500 bg-gray-50">
                <div className="flex flex-col items-center justify-center">
                  <Clock className="h-12 w-12 text-gray-400 mb-3" />
                  <p className="text-lg font-medium text-gray-600 mb-1">Aucun retard enregistré</p>
                  <p className="text-sm text-gray-500">
                    {activeTab === 'etudiants' 
                      ? 'Aucun retard d\'étudiant n\'a été enregistré pour le moment.' 
                      : 'Aucun retard d\'enseignant n\'a été enregistré pour le moment.'}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AssiduiteTable;
